export default "__VITE_PUBLIC_ASSET__619d546d__"